var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"role":"presentation","fill":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","fill":"currentColor","d":"M3 3L3 21L21 21L21 3M10 17L5 12L6.41 10.58813L10 14.1681L17.59 6.57812L19 8L10 17Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }